import {
  MDBCheckbox,
  MDBIcon,
  MDBInputGroup,
  MDBTimepicker
} from "mdb-react-ui-kit";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import remove from "../components/images/remove.svg";
import { formattedNumber } from "../views/popups/phonenumbers/AddRemoveNumbers";


export default function CallRouteDevice({ ditem, seqindex, ondelete, deviceindex, register, getValues, setValue, deviceLength, setAllowSaveFlag, isadd, callerids, isDisabled, watch, size, errors, clearErrors, unregister }) {
  const { t, i18n } = useTranslation();

  const navigate = useNavigate();
  const [enableCallerid, setEnableCallerid] = useState(ditem.callerid_pass_flag ?? true);
  console.log("device info:::::::::: " + JSON.stringify(ditem));

  function deletDevice(e, index, deleteobj, seqindex) {
    ondelete(e, index);
    const deletedeviceid = deleteobj.deviceid
    if (!deleteobj.newDevice) {
      let deviceid = getValues("device_id") ?? [];
      if (deletedeviceid && deletedeviceid !== "") {
        deviceid = [...deviceid, (deletedeviceid + "_" + (seqindex + 1))];
        //alert( watch(`sequences.${seqindex}`));
        // const seqno = getValues(`sequences.${seqindex}.name`).slice(-1);
        setValue("device_id", deviceid, { shouldDirty: true });
        if (deleteobj.editDevice) {
          let deldeviceid = getValues("delete_new_Device") ?? [];
          deldeviceid.push(`${seqindex}_${index}`);
          setValue("delete_new_Device", deldeviceid, { shouldDirty: true });

        }
      }
    } else {
      let deldeviceid = getValues("delete_new_Device") ?? [];
      deldeviceid.push(`${seqindex}_${index}`);
      setValue("delete_new_Device", deldeviceid, { shouldDirty: true });

    }
  }


  useEffect(() => {
    if (isadd) {
      if (deviceLength > 0 && seqindex === 0) {
        setAllowSaveFlag(false);
      } else {
        setAllowSaveFlag(true);
      }
    }
  }, [deviceLength]);

  const [hover, setHover] = useState(false);

  return (



    <>


      <div className="p-2 py-3 device_boxset" onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
        <div>
          <div className="d-flex align-items-center justify-content-between">
            <p className="d-flex"  title={ditem.name}>
              <MDBIcon
                color='secondary'
                fas
                icon={
                  ditem.name.includes('Mobile') ? 'mobile-screen-button' :
                    ditem.name.includes('Desktop') ? 'desktop' :
                      ditem.name.includes('IP Phone') ? 'tty' : 'desktop'
                }
                className="me-2"
              />
                  <p className={`text-primary fw-500 seq-name_ellipsis ${hover ? 'text-truncate' : ''}`}>{ditem.name.includes(":") ? ditem.name.split(":")[0] : ditem.name}</p>
            </p>
            <div className="device-actions">
              {(size > 1 || isadd || deviceLength > 1) && (
                <button
                  className="seq-close-btn bg-danger bg-opacity-25 ms-2"
                  onClick={(e) => deletDevice(e, deviceindex, ditem, seqindex)}
                >
                  <MDBIcon fas icon="times" color='danger' size='md' />
                </button>
              )}
            </div>
          </div>
          <p className="text-muted fw-500 ms-4">
            {ditem.name.includes(":") && (ditem.name.split(":")[1])}
          </p>
          <div className="d-flex align-items-center justify-content-end">
            {/* <MDBCheckbox name='inlineCheck' id='inlineCheckbox1' value='option1' /> */}

            <MDBCheckbox
              className="me-0"
              name="flexCheck"
              defaultChecked={watch(`sequences.${seqindex}.devices.${deviceindex}.is24`)}
              // disabled={issystemroute}
              id={`${seqindex}.devices.${deviceindex}`}
              onChange={(e) => {
                setValue(`sequences.${seqindex}.devices.${deviceindex}.is24`, e.target.checked, { shouldDirty: true });
                if (!watch(`sequences.${seqindex}.devices.${deviceindex}.newDevice`)) {
                  setValue(`sequences.${seqindex}.devices.${deviceindex}.editDevice`, true, { shouldDirty: true });
                }
              }}
            />
            <label htmlFor={`${seqindex}.devices.${deviceindex}`} className='cursor-pointer'>All Day</label>
          </div>
        </div>


        {((ditem?.external_num !== undefined && ditem.external_num != "") || (ditem?.new_external_num !== undefined && ditem.new_external_num != "")) && (
          <>
            <div className="d-flex align-items-center  mb-2">
              <MDBCheckbox name='checkNoLabel' id='checkboxNoLabel'
                defaultChecked={(watch(`sequences.${seqindex}.devices.${deviceindex}.callerid_pass_flag`)) ?? true}
                onChange={(e) => {
                  setValue(`sequences.${seqindex}.devices.${deviceindex}.callerid_pass_flag`, e.target.checked, { shouldDirty: true });
                  if (!watch(`sequences.${seqindex}.devices.${deviceindex}.newDevice`)) {
                    setValue(`sequences.${seqindex}.devices.${deviceindex}.editDevice`, true, { shouldDirty: true });
                  }

                }}
              />
              <label htmlFor="checkboxNoLabel" className='cursor-pointer fw-500 me-2'>Caller ID Pass Through</label>
            </div>

            <select
              className="form-control form-select selectname my-3"
              disabled={watch(`sequences.${seqindex}.devices.${deviceindex}.callerid_pass_flag`)}
              value={(watch(`sequences.${seqindex}.devices.${deviceindex}.callerid_pass`))}
              onChange={(e) => {

                setValue(`sequences.${seqindex}.devices.${deviceindex}.callerid_pass`, e.target.value, { shouldDirty: true });
                if (!watch(`sequences.${seqindex}.devices.${deviceindex}.newDevice`)) {
                  setValue(`sequences.${seqindex}.devices.${deviceindex}.editDevice`, true, { shouldDirty: true });
                }
              }}
            >
              <option value="0">Choose Caller ID...</option>
              {callerids && callerids.length > 0 && callerids.map((item) => (
                <option key={item.phnum} value={item.phnum}>
                  {item.addl_info}
                </option>
              ))}
            </select>
          </>

        )}

        <MDBInputGroup className='my-3 mb-0'>
          <div style={{ width: "50%" }}>
            <MDBTimepicker inputLabel='From'
              inline
              cancelLabel="true"
              defaultValue={watch(`sequences.${seqindex}.devices.${deviceindex}.ftime`)}
              disabled={watch(`sequences.${seqindex}.devices.${deviceindex}.is24`)}
              onChange={(value) => {
                setValue(`sequences.${seqindex}.devices.${deviceindex}.ftime`, value, { shouldDirty: true });
                if (!watch(`sequences.${seqindex}.devices.${deviceindex}.newDevice`)) {
                  setValue(`sequences.${seqindex}.devices.${deviceindex}.editDevice`, true, { shouldDirty: true });
                }
              }}
            />
          </div>
          <div style={{ width: "50%" }}>
            <MDBTimepicker inputLabel='To' inline
              cancelLabel="true"
              defaultValue={watch(`sequences.${seqindex}.devices.${deviceindex}.ttime`)}
              disabled={watch(`sequences.${seqindex}.devices.${deviceindex}.is24`)}
              onChange={(value) => {
                setValue(`sequences.${seqindex}.devices.${deviceindex}.ttime`, value, { shouldDirty: true });
                if (!watch(`sequences.${seqindex}.devices.${deviceindex}.newDevice`)) {
                  setValue(`sequences.${seqindex}.devices.${deviceindex}.editDevice`, true, { shouldDirty: true });
                }
              }}
            />
          </div>
        </MDBInputGroup>
      </div>




      {/* <div className=""> */}
      {/* <div className="sequenceheader">
          <label className="fw-bold">{ditem.name}</label>
          {(size > 1 || isadd || deviceLength > 1) && (
            <img src={remove} className={`close-icon ${isDisabled && 'cursor-notAllowed'}`}
              // disabled={issystemroute ? true : false}
              style={{ cursor: "pointer" }}
              {...(isDisabled ? {
                onClick: (e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }
              } : {
                onClick: (e) => {
                  deletDevice(e, deviceindex, ditem, seqindex)
                }
              }
              )}
            />
          )}

        </div> */}


      {/* {((ditem?.external_num !== undefined && ditem.external_num != "") || (ditem?.new_external_num !== undefined && ditem.new_external_num != "")) && (
          <>
            <div className='mt-2 d-flex align-itemd-center justify-content-between w-100'>
              <small className="tel-numbers fw-bold">{t("CallerIDpasstrough")}</small>
              <MDBCheckbox name='checkNoLabel' id='checkboxNoLabel'
                defaultChecked={(watch(`sequences.${seqindex}.devices.${deviceindex}.callerid_pass_flag`)) ?? true}
                onChange={(e) => {
                  setValue(`sequences.${seqindex}.devices.${deviceindex}.callerid_pass_flag`, e.target.checked, { shouldDirty: true });
                  if (!watch(`sequences.${seqindex}.devices.${deviceindex}.newDevice`)) {
                    setValue(`sequences.${seqindex}.devices.${deviceindex}.editDevice`, true, { shouldDirty: true });
                  }

                }}
              />
            </div>
            <div className="phoneselect mt-1 w-80">
              <select
                className="form-control form-select selectname"
                disabled={watch(`sequences.${seqindex}.devices.${deviceindex}.callerid_pass_flag`)}
                value={(watch(`sequences.${seqindex}.devices.${deviceindex}.callerid_pass`))}
                onChange={(e) => {

                  setValue(`sequences.${seqindex}.devices.${deviceindex}.callerid_pass`, e.target.value, { shouldDirty: true });
                  if (!watch(`sequences.${seqindex}.devices.${deviceindex}.newDevice`)) {
                    setValue(`sequences.${seqindex}.devices.${deviceindex}.editDevice`, true, { shouldDirty: true });
                  }
                }}
              >
                <option value="0">Choose Caller ID...</option>
                {callerids && callerids.length > 0 && callerids.map((item) => (
                  <option key={item.phnum} value={item.phnum}>
                    {item.addl_info}
                  </option>
                ))}
              </select>
            </div>
          </>
        )} */}


      {/* <div className="mx-2">
          <div className="w-100 d-flex justify-content-between align-items-center py-3 bottomline mb-2">
            <MDBTimepicker inline
              cancelLabel="true"
              inputLabel="From"
              defaultValue={watch(`sequences.${seqindex}.devices.${deviceindex}.ftime`)}
              disabled={watch(`sequences.${seqindex}.devices.${deviceindex}.is24`)}
              onChange={(value) => {
                setValue(`sequences.${seqindex}.devices.${deviceindex}.ftime`, value, { shouldDirty: true });
                if (!watch(`sequences.${seqindex}.devices.${deviceindex}.newDevice`)) {
                  setValue(`sequences.${seqindex}.devices.${deviceindex}.editDevice`, true, { shouldDirty: true });
                }

              }}
            // disabled={issystemroute ? true : false}
            />
            <MDBTimepicker inline
              style={{ width: "85px" }}
              cancelLabel="true"
              inputLabel="To"
              defaultValue={watch(`sequences.${seqindex}.devices.${deviceindex}.ttime`)}
              disabled={watch(`sequences.${seqindex}.devices.${deviceindex}.is24`)}
              onChange={(value) => {
                setValue(`sequences.${seqindex}.devices.${deviceindex}.ttime`, value, { shouldDirty: true });
                if (!watch(`sequences.${seqindex}.devices.${deviceindex}.newDevice`)) {
                  setValue(`sequences.${seqindex}.devices.${deviceindex}.editDevice`, true, { shouldDirty: true });
                }

              }}

            // disabled={issystemroute ? true : false}
            />
            <div className="ml-1 sequenceDeviceLabel text-small">
              <MDBCheckbox
                className="me-0"
                name="flexCheck"
                defaultChecked={watch(`sequences.${seqindex}.devices.${deviceindex}.is24`)}
                // disabled={issystemroute}
                id="flexCheckDefault"
                label="All Day"
                onChange={(e) => {
                  setValue(`sequences.${seqindex}.devices.${deviceindex}.is24`, e.target.checked, { shouldDirty: true });
                  if (!watch(`sequences.${seqindex}.devices.${deviceindex}.newDevice`)) {
                    setValue(`sequences.${seqindex}.devices.${deviceindex}.editDevice`, true, { shouldDirty: true });
                  }
                }}
              />
            </div>
          </div>
        </div> */}
      {/* </div> */}



    </>
  );
}
